<template>
    <div>
        <el-form-item label="Liczba newsów na stronę"
                      required
                      :error="errors.page_size">
            <el-input v-model="form.page_size"
                      type="number"/>
        </el-form-item>
        <el-form-item label="Kolor tła"
                      :error="errors['bg_color']">
            <el-color-picker v-model="form.bg_color"/>
        </el-form-item>
        <el-form-item label="Kolor tekstu"
                      :error="errors['text_color']">
            <el-color-picker v-model="form.text_color"/>
        </el-form-item>
        <el-form-item label="Tagi"
                      :error="errors['tags']">
            <el-select v-model="form['tags']"
                       class="fluid"
                       filterable
                       multiple
                       clearable
                       default-first-option
                       placeholder="Tagi">
                <el-option
                        v-for="item in tags"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
    import {News} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                tags: [],
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                News.tags().then(response => {
                    this.tags = response.data
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// NewsWidget.vue?adc01d84